var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteEnd = function SvgQuoteEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7168 1V10.8223C37.7168 14.5014 37.1073 17.8193 35.9043 20.793L35.6553 21.3828C34.3731 24.3062 32.1516 27.3986 28.9424 30.6572L24.2354 26.8643C26.2654 24.6794 27.8074 22.578 28.833 20.5576V20.5566C29.3137 19.6077 29.69 18.6297 29.9707 17.6211L30.3232 16.3525H22.084V1H37.7168Z",
    fill: "#65C9DB",
    stroke: "#65C9DB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6328 1V10.8223C16.6328 14.5014 16.0233 17.8193 14.8203 20.793L14.5713 21.3828C13.2891 24.3062 11.0676 27.3986 7.8584 30.6572L3.15137 26.8643C5.18143 24.6794 6.72344 22.578 7.74902 20.5576V20.5566C8.22972 19.6077 8.60598 18.6297 8.88672 17.6211L9.23926 16.3525H1V1H16.6328Z",
    fill: "#65C9DB",
    stroke: "#65C9DB",
    strokeWidth: 2
  })));
};
export default SvgQuoteEnd;